module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/price_garapon-2eaf9fcc761403cbd2e0c0c905272923.jpg";